var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkill20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.318 32.318",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M566.8,503.946a14.979,14.979,0,1,1,14.979-14.979h0A14.994,14.994,0,0,1,566.8,503.946m0-31.137a16.159,16.159,0,1,0,16.159,16.159h0A16.178,16.178,0,0,0,566.8,472.809",
    transform: "translate(-550.645 -472.809)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.856,478.339l-.02-.014c-.088-.059-.171-.118-.26-.177l-.035-.023-.249-.161-.046-.028-.243-.148-.055-.032c-.08-.046-.161-.094-.243-.139l-.056-.032-.246-.132-.057-.03c-.088-.044-.17-.088-.254-.129l-.051-.025c-.088-.044-.181-.088-.273-.129l-.038-.018c-.1-.046-.207-.088-.312-.138h0c-.32-.138-.647-.265-.978-.372l-.055-.018c-.088-.031-.177-.059-.27-.088l-.094-.027c-.079-.024-.156-.048-.236-.069l-.114-.031c-.072-.02-.146-.039-.218-.056l-.127-.032-.208-.049-.135-.03-.2-.042-.141-.027c-.067-.013-.134-.025-.2-.035l-.143-.025-.2-.03-.147-.02-.2-.026-.148-.017-.208-.02-.146-.013-.216-.014-.139-.008c-.079,0-.16-.007-.239-.01l-.117,0c-.121,0-.239-.006-.36-.006a13.412,13.412,0,1,0,7.689,2.423Zm-7.689,14.5-7.472,3.19,7.472-6.381,7.472,6.381Zm0-4.282-7.472,3.19,7.472-6.381,7.472,6.381Zm0-4.282-7.472,3.19,7.472-6.381,7.472,6.381Z",
    transform: "translate(-551.009 -473.173)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill20);
export default __webpack_public_path__ + "static/media/skill20.1d71130a.svg";
export { ForwardRef as ReactComponent };